export const darkTypography = {};

export const lightTypography = {
  fontFamily: ["Rubik"].join(","),
  subtitle1: {
    lineHeight: 1.6,
    fontSize: "1.15rem",
    fontWeight: 500,
  },
};
